/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/rejectionManagementWizardModal"/>
import * as React from "react";
import { RejectionManagementWizard } from "./rejectionManagementWizard";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { LocalizationContext } from "@medius/ui-controls";
import { RejectedEntityType, RejectionManagementWizardType } from "./interfaces";

export interface RejectionManagementWizardModalProps {
    wizardType: RejectionManagementWizardType;
    documentId: number;
    hierarchyId: string;
    task: string;
    rejectedEntityType: RejectedEntityType;
    show: boolean;
    onClose: () => void;
    action: () => void; 
}

export const RejectionManagementWizardModal: React.FC<RejectionManagementWizardModalProps> = ({ show, ...otherProps }) => {

    if (!show) return null;
    return (
        <LocalizationContext.Provider value={{
                translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
                getLocale: () => getCultureCode()
            }}>
                <RejectionManagementWizard {...otherProps} />
        </LocalizationContext.Provider>
    );
};